import React from 'react';
import cx from 'classnames';
import styles from './Input.module.scss';

const Input = ({ error, ...rest }) => (
  <input className={cx(styles.root, { [styles.root_error]: error })} {...rest} />
);

export default Input;
